// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav-wrapper {
  color: #FFFFFF;
  transition: 0.3s;
}
.nav-wrapper:hover .h-brand {
  color: #ffffff !important;
}

.nav-link {
  border-bottom: solid 2px transparent;
  transition: 0.3s;
  padding-bottom: 0px;
  font-size: 1.25rem;
  font-weight: 600;
  color: #f1eee6;
}
.nav-link.current {
  color: #FAF9F6;
  border-color: #FAF9F6;
  border-width: 4px;
}
.nav-link:hover:not(.current) {
  border-color: #FAF9F6;
  color: #FAF9F6 !important;
}

.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {
  color: #FAF9F6;
  border-color: #FAF9F6;
}

.h-brand {
  transition: 0.3s;
  color: #b4b4b4 !important;
}

.contain {
  background-color: #2a9679;
  margin-top: 5px;
  padding-bottom: 10px;
  border-radius: 50px;
  transition: 0.3s;
}
.contain:hover {
  border-color: #ffffff;
  box-shadow: 0px 8px 16px 2px rgba(68, 68, 68, 0.24);
}

.divider {
  background-color: black;
}

.imglab {
  border: none;
  border-radius: 15px;
}

.filter-white {
  filter: invert(100%) brightness(1000%) grayscale(100%) sepia(0%) saturate(7489%) hue-rotate(291deg) brightness(115%) contrast(100%);
}`, "",{"version":3,"sources":["webpack://./src/components/Navbar/HNavbar.scss","webpack://./src/scss/colors.scss"],"names":[],"mappings":"AAGA;EAEE,cCHM;EDON,gBAAA;AANF;AAYI;EACE,yBAAA;AAVN;;AAeA;EACE,oCAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cChBe;ADIjB;AAcE;EACE,cCzBQ;ED0BR,qBC1BQ;ED2BR,iBAAA;AAZJ;AAeE;EACE,qBC/BQ;EDgCR,yBAAA;AAbJ;;AAiBA;EACE,cCrCU;EDsCV,qBCtCU;ADwBZ;;AAiBA;EACE,gBAAA;EACA,yBAAA;AAdF;;AAiBA;EACE,yBCjDS;EDkDT,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;AAdF;AAgBE;EACE,qBCtCc;EDuCd,mDAAA;AAdJ;;AAkBA;EACE,uBAAA;AAfF;;AAkBA;EACE,YAAA;EACA,mBAAA;AAfF;;AAkBA;EACE,mIAAA;AAfF","sourcesContent":["@import \"../../scss/colors\";\n@import \"../../scss/globals\";\n\n.nav-wrapper {\n  // border-radius: $nav-radius;\n  color: $white;\n  // box-shadow: 0px 8px 16px 2px rgba(68,68,68,0.14);\n\n  // border: solid 1px $nav-outline;\n  transition: 0.3s;\n\n  &:hover {\n    // border-color: $nav-outline-hvr;\n    // box-shadow: 0px 8px 16px 2px rgba(68,68,68,0.24);\n\n    .h-brand {\n      color: $text-light !important;\n    }\n  }\n}\n\n.nav-link {\n  border-bottom: solid 2px transparent;\n  transition: 0.3s;\n  padding-bottom: 0px;\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: $palette-3-dark;\n\n  &.current {\n    color: $palette-3;\n    border-color: $palette-3;\n    border-width: 4px;\n  }\n\n  &:hover:not(.current) {\n    border-color: $palette-3;\n    color: $palette-3 !important;\n  }\n}\n\n.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {\n  color: $palette-3;\n  border-color: $palette-3;\n}\n\n.h-brand {\n  transition: 0.3s;\n  color: $text-ghost !important;\n}\n\n.contain {\n  background-color: $palette-1;\n  margin-top: 5px;\n  padding-bottom: 10px;\n  border-radius: 50px;\n  transition: 0.3s;\n\n  &:hover {\n    border-color: $nav-outline-hvr;\n    box-shadow: 0px 8px 16px 2px rgba(68, 68, 68, 0.24);\n  }\n}\n\n.divider {\n  background-color: black;\n}\n\n.imglab {\n  border: none;\n  border-radius: 15px;\n}\n\n.filter-white {\n  filter: invert(100%) brightness(1000%) grayscale(100%) sepia(0%) saturate(7489%) hue-rotate(291deg) brightness(115%) contrast(100%);\n}","\n$black: #011627;\n$white: #FFFFFF;\n$palette-1:#2a9679;\n$palette-2: #6564DB;\n$palette-3: #FAF9F6;\n\n$palette-1-dark: darken($palette-1, 5%);\n$palette-1-light: lighten($palette-1, 10%);\n$palette-2-dark: darken($palette-2, 10%);\n$palette-2-light: lighten($palette-2, 10%);\n$palette-3-dark: darken($palette-3, 5%);\n$palette-3-darker: darken($palette-3, 10%);\n$palette-3-light: lighten($palette-3, 10%);\n\n$text-host: #F06543;\n$text-host-light: lighten($text-host, 15%);\n$text-pathogen: #A68F26;\n$text-pathogen-light: lighten($text-pathogen, 20%);\n\n$nav-outline: #ffffff;\n$nav-outline-hvr: #ffffff;\n\n$text-ghost: #b4b4b4;\n$text-light:#ffffff;\n$text-main: #393939;\n$text-hard: #212121;\n\n$color-light-grey: #c9c9c9;\n\n$palette-1-v-light: #abeef0;\n\n$palette-1-bg: #e2fcfc;\n$palette-2-bg: #ffe4eb;\n\n$chip-bg: #def5ff;\n$chip-font: #036778;\n\n$palette-1-pastel: #a9fafc;\n\n// $nav-back:#4fa2a2;\n$nav-back:#288DC2;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
